import React, { useState, useContext } from 'react';
import { Context } from '../../context/AuthContext';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Form, Col, InputGroup, Button } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import If from '../../components/If';
import AlertError from '../../components/AlertError';
import LoadingInForm from '../../components/LoadingInForm';
import { STRINGS } from '../../util/strings';
import { colors } from '../../util/colors';
import logo from '../../assets/logoColor.svg';
import './styles.css';

function Login() {
	const { handleLogin } = useContext(Context);
	const [clicked, setClicked] = useState<boolean>(false);
	const [showPassword, setShowPassword] = useState<boolean>(false);
	const [errorLogin, setErrorLogin] = useState<string>('');

	const loginSchema = yup.object().shape({
		username: yup.string().required(STRINGS.FORM_FIELD_REQUIRED),
		password: yup.string().required(STRINGS.FORM_FIELD_REQUIRED)
	})

	const { handleSubmit, register, errors, getValues } = useForm({
		defaultValues: {
			username: '',
			password: ''
		},
		mode: 'onTouched',
		resolver: yupResolver(loginSchema)
	})

	const login = (data: any) => {
		setErrorLogin('');
		const response = handleLogin(data);

		response.then((res: any) => {
			if (res && res.data && res.data.status === 401) {
				setErrorLogin(STRINGS.ERROR_LOGIN_401);
				setClicked(false);
			} else if(res && res.data && res.data.status !== 200){
				setErrorLogin(STRINGS.ERROR_LOGIN_500)
				setClicked(false);
			}
		})
	}

	return (
		<div className="card-container">
			<div className="card">
				<span className="logo">
					<img src={logo} alt="logo basf" />
				</span>
				<Form onSubmit={handleSubmit(login)}>
					<If condition={errors.username || errors.password}>
						<AlertError message={STRINGS.ALERT_WARNING_FIELDS} />
					</If>
					<If condition={errorLogin}>
						<AlertError message={errorLogin} />
					</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>
								Usuário<em>*</em>
							</Form.Label>
							<Form.Control
								ref={register}
								name="username"
								isInvalid={!!errors.username}
								type="text"
								autoComplete="off"
								maxLength={100}
							/>
						</Form.Group>
					</Form.Row>
					<Form.Row>
						<Form.Group as={Col}>
							<Form.Label>
								Senha<em>*</em>
							</Form.Label>
							<InputGroup className="mb-3">
								<Form.Control
									ref={register}
									name="password"
									isInvalid={!!errors.password}
									type={showPassword ? 'text' : 'password'}
									maxLength={100}
								/>
								<InputGroup.Append>
									<Button variant={errors.password ? "outline-danger" : "outline-secondary"} onClick={() => setShowPassword(!showPassword)}>
										{!showPassword ? <FaEyeSlash size={18} color={colors.gray2} /> : <FaEye size={18} color={colors.green4} />}
									</Button>
								</InputGroup.Append>
							</InputGroup>
						</Form.Group>
					</Form.Row>
					<Form.Row>
						<Form.Group as={Col}>
							<Button
								variant="success"
								size="lg"
								block
								type="submit"
								onClick={() => {
									if (getValues('username').length && getValues('password').length) {
										setClicked(true);
									}
								}}
							>
								{clicked ? <LoadingInForm color={colors.white} /> : 'Entrar'}
							</Button>
						</Form.Group>
					</Form.Row>
				</Form>
			</div>
		</div>
	);
}

export default Login;
